import styled from "styled-components";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import { MenuItem } from "@mui/material";

export const StyledButton = styled.button`
width: 100%;
  margin: 0;
  display: block;
  padding: 4px 1.4rem;
  font-size: 0.75rem;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #f4f4f4;
  }
`;

export const CircleWrapper = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background-color: rgba(254, 47, 103, 0.3);
  }
`;

export const NotificationCircle = styled.div<{ color?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ color }) => color || "#FE2F67"};
  flex-shrink: 0;
`;

export const StyledText = styled.p`
  margin: 0;
  font-size: 0.75rem;
  text-wrap: wrap;
`;

export const StyledNoHoverMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    pointer-events: none;
  }
}`

export const StyledAvatar = styled(Avatar)`
  &.MuiAvatar-root {
    width: 1.75rem;
    height: 1.75rem;
    margin-right: 6px;
  }
`;

export const StyledPaper = styled(Paper)`
  &.MuiPaper-root {
    position: absolute;
    top: calc(100% + 0.01rem);
    right: 1rem;
    z-index: 1000;
    width: clamp(240px, 32vw, 280px);
    max-width: calc(100vw - 2rem);
    max-height: calc(70vh - 5rem);
    min-height: calc(40vh - 5rem);
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 0px 0px 0px 8px;
    margin-right: 0.9rem;
    border: 1px solid #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .compact {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }

    .MuiDivider-root {
      margin: 0.25rem 0;
    }

    .MuiMenuItem-root {
      padding: 0.55rem 1rem;
      column-gap: 0.6rem;
    }

    .MuiListItemIcon-root {
      min-width: 24px;
    }

    .MuiSvgIcon-root {
      font-size: 1.1rem;
    }

    .MuiListItemText-root span,
    .MuiTypography-root {
      font-size: 0.85rem;
    }
  }
`;
